import { createRouter, createWebHistory } from "vue-router"

// 路由
const routes = [
  {
    path: "/",
    redirect: "/home/jsonformat",
  },
  {
    path: "/home/jsonformat",
    component: () => import("@/modules/json/jsonformat"),
  },
  {
    path: "/home/jsonmodel",
    component: () => import("@/modules/json/jsonmodel"),
  },
  {
    path: "/home/jsonxml",
    component: () => import("@/modules/json/jsonxml"),
  },
  {
    path: "/home/xmlformat",
    component: () => import("@/modules/xml/xmlformat"),
  },
  {
    path: "/home/xmlmodel",
    component: () => import("@/modules/xml/xmlmodel"),
  },
  {
    path: "/home/xmljson",
    component: () => import("@/modules/xml/xmljson"),
  },
  {
    path: "/home/expression",
    component: () => import("@/modules/regular/expression"),
  },
  {
    path: "/home/md5sha",
    component: () => import("@/modules/string/md5sha"),
  },
  {
    path: "/home/qrcode",
    component: () => import("@/modules/qrcode/qrcode"),
  },
  {
    path: "/home/colors",
    component: () => import("@/modules/utils/colors"),
  },
  {
    path: "/home/wordart",
    component: () => import("@/modules/text/asciiwordart"),
  },
  {
    path: "/home/generateguid",
    component: () => import("@/modules/string/generateguid"),
  },
  {
    path: "/home/stringcalc",
    component: () => import("@/modules/string/stringcalc"),
  },
  {
    path: "/home/timezone",
    component: () => import("@/modules/utils/timezone"),
  },
  // {
  //   path: "/home/api",
  //   component: () => import("@/modules/utils/api"),
  // },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
